import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — restores window scroll position to (0, 0) on every route
 * change. Without this, react-router preserves the scroll position from the
 * previous page (e.g., clicking the Pip Bennett brand link from a long
 * program page drops you on the homepage halfway down).
 *
 * Anchor links (#waitlist, #what-inside, etc.) still work — they bypass this
 * by setting location.hash, which we honour explicitly.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Hash links: scroll the target into view instead of jumping to top.
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "instant", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
